export default __webpack_public_path__ + "static/media/black.74860d04.webp";